/**
 * Dependency Injection Module: Auth
 * Configures inversify container for auth feature
 */

import { Container } from "inversify";
import { AuthApiService } from "../data/remote/service/AuthApiService";
import { AuthRepositoryImpl } from "../data/repository/AuthRepositoryImpl";
import type { IAuthRepository } from "../domain/repository/IAuthRepository";

const TYPES = {
  IAuthRepository: Symbol.for("IAuthRepository"),
};

const container = new Container();

container
  .bind<IAuthRepository>(TYPES.IAuthRepository)
  .to(AuthRepositoryImpl)
  .inSingletonScope();

container.bind(AuthApiService).toSelf().inSingletonScope();

export { container, TYPES };

